import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;
import { GridOptions } from "ag-grid/main";
import { Router } from "@angular/router";
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { AdminService, RaterTypeDto } from 'app/services/admin/AdminService';

@Component({
  selector: 'app-rater-types',
  templateUrl: './rater-types.component.html',
  styleUrls: ['./rater-types.component.scss']
})
export class RaterTypesComponent implements OnInit {

    data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    currentRowIndex: number;
    action: string;
    name: string = '';
    min: number = 3;
    currentRaterId: number;
    loading: boolean = false;

    constructor
        (
            private _AdminService: AdminService,
            private router: Router,
            private _Globals: Globals,
            private _toastr: ToastrService
    )
    {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        this.getGlobalRaterTypes();
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);

            if (this._Globals.validationToken(data.result.Result)) {
                this.data = JSON.parse(data.result.Data);
                console.log('this.data', this.data);
            }
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();      

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        //let minHeader = {
        //    headerName: 'Min',
        //    field: 'Min',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(minHeader);        

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log(data);
            this.openModal('Edit', data['Id'], data['Name']);//, data['Min']);
        }
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    editSelected() {
        if (this.canEdit) {
            let data = this.getSelectedRows();
            console.log("SELECTED ID", data);

            this.edit(data[0].Id);
        }
    }

    deleteSelected() {
        if (this.canDelete) {
            let data = this.getSelectedRows();
            console.log("SELECTED ID", data[0].Id);

            this.delete(data[0].Id);
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    edit(id: number) {
        console.log('edit');
        this.router.navigate(['/app/edit_emailtemplate', id]);
    }

    delete(id: number) {
        console.log('delete', id);
    }


    /*Rater METHODS*/

    openModal(action: string, raterId: number, raterName: string) { //, raterMin?: number) {
        this.action = action;
        this.currentRaterId = raterId;
        this.name = raterName;
        //if (!isUndefined(raterMin)) this.min = raterMin;

        $("#createEditModal").modal({ backdrop: "static" });
        $('#createEditModal').modal('show');
    }

    closeModal() {
        $('#createEditModal').modal('hide');
    }

    saveRater() {
        let raterType = new RaterTypeDto;
        raterType.Id = this.currentRaterId;
        raterType.Name = this.name;
        raterType.Min = this.min;
        raterType.IsGlobal = true;

        if (raterType.Name === "") {
            this._toastr.warning("The field name can not be empty.", "ELI");
            return;
        }

        //if (raterType.Min === null || raterType.Min < 0) {
        //    this._toastr.warning("Invalid entry for Min field.", "ELI");
        //    return;
        //}

        this.SaveRaterType(raterType);
    }

    SaveRaterType(raterType: RaterTypeDto) {
        this.loading = true;
        this._AdminService.postSaveRaterType(raterType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('data', data);
                this.getGlobalRaterTypes();
                this.closeModal();
                this.loading = false;
            } 
        })
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    /*DELETE MODAL*/

    deleteRaterType() {
        this._AdminService.postDeleteRaterType(this.currentRaterId).subscribe((data: any) => {
            console.log('response_DeleteRaterType', data.result.Result);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 1:
                        this.getGlobalRaterTypes();
                        this.closeModalConfirmation();
                        this.closeModal();
                        this._toastr.success("Relationship deleted successfully", "ELI");
                        break;
                    case 0:
                        this._toastr.error("We are sorry.  An error happened while trying to delete the relationship", "ELI");
                        break;
                    case -1:
                        this._toastr.warning("This relationship cannot be deleted since it is being used in assessment assignments", "ELI");
                        break;
                }
            }
        });
    }

    /*Confirmation Delete*/

    openConfirmationModal() {
        $("#confirmationDeleteModal").modal({ backdrop: "static" });
        $('#confirmationDeleteModal').modal('show');
    }

    closeModalConfirmation() {
        $('#confirmationDeleteModal').modal('hide');
    }



}

